import http from '../../utils/httpClient';
import swal from 'sweetalert2';
import moment from 'moment';
import { LANGUAGES } from '../../constants/localization/languageList';
const state = {
  isValidKey: false,
  language: [],
  languageJSONtoCSV: [],
  uploadResult: {},
  createLanguage: {},
  updateLanguage: {},
  updateLanguagePrev: {},
  subtitleLocalizationData: {},
  isValidSubtitle: false,
  existingSubtitleLocalizationList: [],
  selectedSubtitleLocalization: [],
  isSafeDelete: '',
};
const getters = {};
const actions = {
  validateDuplicateSubtitle({ commit }, English) {
    http
      .GET(`/api/subtitle_localization/duplicateSubtitle?English=${English}`, {
        isAuthorization: true,
      })
      .then(response => {
        if (response.data.status === 'OK') {
          commit('SET_DUPLICATE_SUBTITLE_RESULT', true);
        }
      })
      .catch(error => {
        if (error.response.status === 409) {
          commit('SET_DUPLICATE_SUBTITLE_RESULT', false);
          commit(
            'SET_EXISTING_SUBTITLE_LOCALIZATION_LIST',
            error.response.data.content,
          );
        }
      });
  },
  getSubtitleLocalizationDataByEnglish({ commit }, English) {
    http
      .GET(`/api/subtitle_localization/filter?English=${English}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        commit('SET_SELECTED_SUBTITLE_LOCALIZATION', data[0]);
      })
      .catch(error => {});
  },
  getSubtitleLocalizationDataBySubtitleIDAndEnglish(
    { commit },
    { subtitle_id, English },
  ) {
    http
      .GET(
        `/api/subtitle_localization/filter?subtitle_id=${subtitle_id}&English=${English}`,
        { isAuthorization: true },
      )
      .then(response => {
        commit('storeSubtitleLocalization', response.data[0]);
      })
      .catch(error => {});
  },
  checkDuplicateKey({ commit }, ID) {
    http
      .GET(`/api/subtitle_localization/duplicate?ID=${ID}`, {
        isAuthorization: true,
      })
      .then(response => {
        commit('storeDuplicateID', response.data.valid);
      })
      .catch(error => {
        if (error.response.status === 409) {
          commit('storeDuplicateID', error.response.data.valid);
        }
      });
  },
  fetchLanguage({ commit, dispatch }, language) {
    http
      .GET(`/api/subtitle_localization/specific?language=${language}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        const languageData = data.data.map(language => ({
          ...language,
          created_at: moment(language.created_at).format('YYYY MMMM D h:mm A'),
          updated_at: moment(language.updated_at).format('YYYY MMMM D h:mm A'),
        }));
        commit('storeLanguage', languageData);
      })
      .catch(error => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message:
              'Cannot fetch language at this time, please try again later.',
            type: 'error',
          },
          {
            root: true,
          },
        );
      });
  },
  uploadLanguageDataToS3({ commit, dispatch }, language) {
    const languageData = {
      language: language,
    };
    // const timestamp = {
    //   updated_localized: new Date(),
    // };
    swal
      .fire({
        titleText: `Confirm Upload '${language}'`,
        text: 'This operation cannot be undone. Would you like to proceed?',
        confirmButtonColor: 'primary',
        confirmButtonText: 'Upload',
        showCancelButton: true,
        type: 'warning',
      })
      .then(response => {
        if (response.value) {
          http
            .POST(`/api/subtitle_localization/upload`, languageData, {
              isAuthorization: true,
            })
            .then(({ data }) => {
              commit('storeUploadResult', data);
              // dispatch('publishTimestamp', timestamp);
              dispatch(
                'appConfig/toggleAlert',
                {
                  type: 'success',
                  message: `${language} Successfully Uploaded`,
                },
                {
                  root: true,
                },
              );
            })
            .catch(error => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message:
                    'Cannot upload language file at this time, please try again later.',
                  type: 'error',
                },
                {
                  root: true,
                },
              );
            });
        }
      });
  },
  convertJSONtoCSV({ commit, dispatch }, language) {
    http
      .GET(`/api/subtitle_localization/json?language=${language}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        let languageData = data;
        commit('storeLanguageJSONtoCSV', languageData);
      })
      .catch(error => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message:
              'Cannot convert JSON to CSV at this time, please try again later.',
            type: 'error',
          },
          {
            root: true,
          },
        );
      });
  },
  addLanguage({ dispatch }, { languageData, selectedLanguage }) {
    dispatch(
      'appConfig/toggleAlert',
      {
        type: 'info',
        message: 'Adding Language',
      },
      {
        root: true,
      },
    );
    http
      .POST('/api/subtitle_localization', languageData, {
        isAuthorization: true,
      })
      .then(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'success',
            message: 'Language Successfully Created',
          },
          {
            root: true,
          },
        );
        dispatch('fetchLanguage', selectedLanguage);
      })
      .catch(error => {
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'error',
            message: error.response.data,
          },
          {
            root: true,
          },
        );
      });
  },
  publishTimestamp({ dispatch }, selectedLanguage) {
    dispatch(
      'appConfig/toggleAlert',
      {
        type: 'info',
        message: 'Publishing to Server',
      },
      {
        root: true,
      },
    );
    http
      .PATCH('/api/subtitle_localization/publish', selectedLanguage, {
        isAuthorization: true,
      })
      .then(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'success',
            message: 'Timestamp of selected language has been updated',
          },
          {
            root: true,
          },
        );
      })
      .catch(error => {
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'error',
            message: error.response.data.message,
          },
          {
            root: true,
          },
        );
      });
  },
  publishToProduction({ dispatch }) {
    const timestamp = {
      updated_localized: new Date(),
    };
    dispatch(
      'appConfig/toggleAlert',
      {
        type: 'info',
        message: 'Publishing to Production Server',
      },
      {
        root: true,
      },
    );
    http
      .PUT_PROD('/api/subtitle_localization/publish', timestamp, {
        isAuthorization: true,
      })
      .then(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'success',
            message: 'Timestamp and file has been updated',
          },
          {
            root: true,
          },
        );
      })
      .catch(error => {
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'error',
            message: error.response.data.message,
          },
          {
            root: true,
          },
        );
      });
  },
  editLanguage({ dispatch }, { updateData, selectedLanguage }) {
    dispatch(
      'appConfig/toggleAlert',
      {
        type: 'info',
        message: 'Updating Language',
      },
      {
        root: true,
      },
    );
    http
      .PUT('/api/subtitle_localization', updateData, {
        isAuthorization: true,
      })
      .then(() => {
        dispatch('publishTimestamp', selectedLanguage);
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'success',
            message: 'Language Successfully Updated',
          },
          {
            root: true,
          },
        );
        dispatch('fetchLanguage', selectedLanguage);
      })
      .catch(error => {
        dispatch(
          'appConfig/toggleAlert',
          {
            type: 'error',
            message: error.response.data.message,
          },
          {
            root: true,
          },
        );
      });
  },
  isAbleToDelete({ commit, dispatch }, { id, English, selectedLanguage }) {
    http
      .GET(`/api/subtitle_localization/isAbleToDelete?English=${English}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
        commit('SET_STAUTS_IS_ABLE_TO_DELETE', data.status);
        if (data.status === 'notsafe') {
          dispatch(
            'appConfig/toggleAlert',
            {
              type: 'warning',
              message: 'This word is not safe to delete',
            },
            {
              root: true,
            },
          );
          swal.fire({
            title: 'Failed Delete ',
            type: 'error',
            text: 'This word is not safe to delete, please ensure that there is no other subtitle using this word!',
            timer: 15000,
          });
        } else {
          dispatch(
            'appConfig/toggleAlert',
            {
              type: 'info',
              message: 'This word is safe to delete',
            },
            {
              root: true,
            },
          );
          dispatch('deleteLanguage', {
            id: id,
            English: English,
            selectedLanguage: selectedLanguage,
          });
        }
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  deleteLanguage({ dispatch }, { id, English, selectedLanguage }) {
    swal
      .fire({
        titleText: `Confirm Delete '${English}'`,
        text: 'This operation cannot be undone. Would you like to proceed?',
        confirmButtonColor: 'red',
        confirmButtonText: 'Remove',
        showCancelButton: true,
        type: 'warning',
      })
      .then(response => {
        if (response.value) {
          dispatch(
            'appConfig/toggleAlert',
            {
              type: 'info',
              message: 'Deleting Language',
            },
            {
              root: true,
            },
          );
          http
            .DELETE(`/api/subtitle_localization?_id=${id}`, {
              isAuthorization: true,
            })
            .then(() => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  type: 'success',
                  message: 'Language Successfully Deleted',
                },
                {
                  root: true,
                },
              );
              dispatch('fetchLanguage', selectedLanguage);
            })
            .catch(error => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  type: 'error',
                  message: error.response.data,
                },
                {
                  root: true,
                },
              );
            });
        }
      });
  },
  statePreviousData({ commit }, { key, value }) {
    commit('storeUpdateLanguagePrevData', {
      key,
      value,
    });
  },
  stateEditLanguage({ commit }, { key, value }) {
    commit('storeUpdateLanguageData', {
      key,
      value,
    });
  },
  stateCreateLanguage({ commit }, { key, value }) {
    commit('storeCreateLanguageData', {
      key,
      value,
    });
  },
  validateLanguage(value) {
    let key = Object.keys(value)[1];
    const languageList = LANGUAGES;
    if (languageList.includes(key)) {
      return key;
    }
  },
  clearCreateState({ commit }) {
    commit('clearCreateState');
  },
  clearUpdateState({ commit }) {
    commit('clearUpdateState');
  },
  clearUpdatePrevState({ commit }) {
    commit('clearUpdatePrevState');
  },
  resetExistingSubtitleLocalizationList({ commit }) {
    commit('RESET_EXISTING_SUBTITLE_LOCALIZATION_LIST');
  },
  resetSelectedSubtitleLocalization({ commit }) {
    commit('RESET_SELECTED_SUBTITLE_LOCALIZATION');
  },
};
const mutations = {
  SET_EXISTING_SUBTITLE_LOCALIZATION_LIST(state, value) {
    if (value) {
      state.existingSubtitleLocalizationList = value;
    } else {
      delete state.existingSubtitleLocalizationList;
    }
  },
  RESET_EXISTING_SUBTITLE_LOCALIZATION_LIST(state) {
    state.existingSubtitleLocalizationList = [];
  },
  SET_STAUTS_IS_ABLE_TO_DELETE(state, payload) {
    state.isSafeDelete = payload;
  },
  RESET_STAUTS_IS_ABLE_TO_DELETE(state) {
    state.isSafeDelete = '';
  },
  SET_DUPLICATE_SUBTITLE_RESULT(state, payload) {
    state.isValidSubtitle = payload;
  },
  SET_SELECTED_SUBTITLE_LOCALIZATION(state, payload) {
    state.selectedSubtitleLocalization = payload;
  },
  RESET_SELECTED_SUBTITLE_LOCALIZATION(state) {
    state.selectedSubtitleLocalization = [];
  },
  storeSubtitleLocalization(state, payload) {
    state.subtitleLocalizationData = payload;
  },
  storeDuplicateID(state, ID) {
    state.isValidKey = ID;
  },
  storeLanguage(state, value) {
    if (value) {
      state.language = value;
    } else {
      delete state.language;
    }
  },
  storeUploadResult(state, value) {
    if (value) {
      state.uploadResult = value;
    } else {
      delete state.uploadResult;
    }
  },
  storeLanguageJSONtoCSV(state, value) {
    if (value) {
      state.languageJSONtoCSV = value;
    } else {
      delete state.languageJSONtoCSV;
    }
  },
  storeCreateLanguageData(state, { key, value }) {
    state.createLanguage = {
      ...state.createLanguage,
      [key]: value,
    };
  },
  storeUpdateLanguagePrevData(state, { key, value }) {
    state.updateLanguagePrev = {
      ...state.updateLanguagePrev,
      [key]: value,
    };
  },
  storeUpdateLanguageData(state, { key, value }) {
    state.updateLanguage = {
      ...state.updateLanguage,
      [key]: value,
    };
  },
  clearCreateState(state) {
    state.createLanguage = {};
  },
  clearUpdateState(state) {
    state.updateLanguage = {};
  },
  clearUpdatePrevState(state) {
    state.updateLanguagePrev = {};
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
